import React from "react";
import { Col, KeyValue, Row } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export var FieldRow = function (_a) {
    var labelId = _a.labelId, value = _a.value;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 12 },
            React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: labelId }), value: value != null
                    ? typeof value === "string" || typeof value === "boolean"
                        ? value.toString()
                        : value
                    : undefined }))));
};
